import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import lang from '@/lang'
import PageWrapper from './components/pageWrapper'
import AddressInputs from './components/addressInputs'
import TaxConsultantAddressInputs from './components/taxConsultantAddressInputs'
import { isMeinBuero } from '@/utils/build-env'
import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'

const eventOmo = 'Addressdaten'

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    margin: 0,
  },
}))

const OnboardingCompanyAddress = (props) => {
  const classes = useStyles()
  const { tenant: { info: { subscriptions } }, wizard: { config: { step, totalSteps } }, onboarding: { mainV2 } } = useSelector(state => state)
  const isTaxConsultant = subscriptions?.some(s => s.isTaxConsultant === true)
  const { companyName } = mainV2?.companyData
  const subscriptionTypeTypesLabel = subscriptions?.map(s => s.typeOfSubscription).join(', ') || ''

  const [inputsValid, setInputsValid] = useState(true)

  const onTaxConsultantButtonClick = () => {
    return true
  }

  const onButtonClick = () => {
    if (ENV.product === 'meinbuero') {
      GtmService.pushEvent({
        'event': GtmEventTypes.MboOnboarding,
        'mbo-onboarding-step': 'kontaktdaten-complete',
      })
    } else {
      GtmService.pushEvent({
        'event': GtmEventTypes.GaEventHub,
        'eventCategory': 'Onboarding',
        'eventAction': 'Weiter',
        'eventLabel': `${eventOmo} abgeschlossen ${subscriptionTypeTypesLabel} (${step}/${totalSteps})`,
      })
    }
    return true
  }

  const onSkipButtonClick = () => {
    if (ENV.product === 'orgamax' && !isTaxConsultant) {
      GtmService.pushEvent({
        'event': GtmEventTypes.GaEventHub,
        'eventCategory': 'Onboarding',
        'eventAction': 'Übersprungen',
        'eventLabel': `${eventOmo} übersprungen ${subscriptionTypeTypesLabel} (${step}/${totalSteps})`,
      })
    }
  }

  const onBackButtonClick = () => {
    if (ENV.product === 'orgamax' && !isTaxConsultant) {
      GtmService.pushEvent({
        'event': GtmEventTypes.GaEventHub,
        'eventCategory': 'Onboarding',
        'eventAction': 'Zurück',
        'eventLabel': `${eventOmo} zurück ${subscriptionTypeTypesLabel} (${step}/${totalSteps})`,
      })
    }
    return true
  }

  return (
    <PageWrapper
      skippable={!isTaxConsultant}
      onSkipButtonClick={onSkipButtonClick}
      title={isTaxConsultant
        ? lang.onboardingV2.taxConsultantCompanyAddress.title
        : isMeinBuero()
          ? lang.onboardingV2.companyAddress.title({ companyName })
          : lang.onboardingV2.companyAddress.title}
      text={isTaxConsultant ? lang.onboardingV2.taxConsultantCompanyAddress.text : lang.onboardingV2.companyAddress.text}
      onNextButtonClick={isTaxConsultant && isMeinBuero() ? onTaxConsultantButtonClick : onButtonClick}
      onBackButtonClick={onBackButtonClick}
      disabled={!inputsValid}
    >
      <form className={classes.form}>
        {isTaxConsultant
          ? (
            <TaxConsultantAddressInputs setInputsValid={setInputsValid} />
          )
          : (
            <AddressInputs setInputsValid={setInputsValid} />
          )}
      </form>
    </PageWrapper>
  )
}
OnboardingCompanyAddress.propTypes = {
  onClose: PropTypes.func,
}

export default OnboardingCompanyAddress
